import {Injectable, signal} from '@angular/core';
import {defaultRecordsDataRequestQueryParams} from "../../../../models/default-records-data-request-query-params";
import {RecordsDataRequestQueryParams} from "../../../../types/records-table.types";

@Injectable({
  providedIn: 'root'
})
export class BankDetailsRequestQueryParamsStateService {
  private _bankDetailsRequestQueryParamsState = signal<RecordsDataRequestQueryParams>(defaultRecordsDataRequestQueryParams);
  public bankDetailsRequestQueryParamsState = this._bankDetailsRequestQueryParamsState.asReadonly();

  public updateRecordsDataRequestQueryParams(bloggerId: number | null): void {
    this._bankDetailsRequestQueryParamsState.update((current) => {
      return {
        ...current,
        size: undefined,
        bloggerId: bloggerId
      };
    });
  }

  public resetRecordsDataRequestQueryParams(): void {
    this._bankDetailsRequestQueryParamsState.set(defaultRecordsDataRequestQueryParams);
  }
}
